import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStrategy = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 36,
	viewBox: "0 0 36 36",
	width: 36,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 18,
		cy: 18,
		fill: "#57ad00",
		r: 18
	}), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "#fff",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m579.8 136.163c-1.971-1.281-3.644-3.4-2.493-5.892s5.917-2.926 8.093-5.37c1.971 2.249 2.078 5.983.316 8.924a5.029 5.029 0 0 1 -4.479 2.242",
				transform: "translate(-572.131 -118.901)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m589.52 127.254a11.014 11.014 0 1 1 -4.233 2.164",
				transform: "translate(-573.664 -119.603)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m608.333 140.015h-1.153a.944.944 0 0 1 -.785-.42l-.545-.817a.944.944 0 0 0 -.785-.42h-.209a.942.942 0 0 0 -.667.276.945.945 0 0 1 -.667.277h-.876a.943.943 0 0 1 -.667-.277l-2.209-2.209a.944.944 0 0 0 -.667-.276h-2.533a.943.943 0 0 1 -.943-.943v-.162a2.21 2.21 0 0 1 2.21-2.21h.714a.945.945 0 0 0 .667-.277l.553-.552a.942.942 0 0 1 .667-.276h1.98a.947.947 0 0 0 .667-.276l.829-.829",
				transform: "translate(-578.714 -120.916)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m599.561 150.571h-.325a.943.943 0 0 1 -.943-.943v-2.028a1.889 1.889 0 0 0 -.689-1.458l-.13-.107a1.892 1.892 0 0 0 -1.2-.431h-.717a.578.578 0 0 1 -.578-.578v-.707a.9.9 0 0 1 .263-.635l.591-.591a2.743 2.743 0 0 1 1.94-.8h.491a2.743 2.743 0 0 1 1.939.8l1.682 1.682a.943.943 0 0 1 .276.667v2.534a.943.943 0 0 1 -.276.667l-1.657 1.657a.943.943 0 0 1 -.667.271z",
				transform: "translate(-578.487 -125.023)"
			})
		]
	})]
});
export default SvgStrategy;
